/*eslint-disable*/
import React, { useState } from 'react';
import { NavLink as NavLinkRRD, Link } from 'react-router-dom';
// nodejs library to set properties for components
import { PropTypes } from 'prop-types';

// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  Collapse,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';
import SubSideBar from './SubSideBar';
import { logout } from 'services/auth';
import { countSyncToSend } from 'config/api';
import { syncRequests } from 'services/auth';
import { syncToSend } from 'config/api';
import { getSync } from 'config/api';
import { setSyncRequests } from 'services/auth';
import { Notification } from 'notification/notification';
import LocalForageBackup from 'components/backup/backup';

var ps;

const Sidebar = (props) => {
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);
  const [collapseOpen, setCollapseOpen] = useState();
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? 'active' : '';
  };
  // toggles collapse between opened and closed (true/false)
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse
  const closeCollapse = () => {
    setCollapseOpen(false);
  };
  // creates the links that appear in the left menu / Sidebar
  const createLinks = (routes) => {
    return routes.map((props, key) => {
      if (props.subSideBar === undefined) {
        return (
          <NavItem
            key={key}
            style={
              props.show && props.show !== undefined ? {} : { display: 'none' }
            }
          >
            <NavLink
              to={props.layout + props.path}
              tag={NavLinkRRD}
              onClick={closeCollapse}
              activeClassName='active'
            >
              <i className={props.icon} />
              {props.name}
            </NavLink>
          </NavItem>
        );
      }

      return <SubSideBar data={props} key={key} />;
    });
  };

  const { routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: '_blank',
    };
  }

  return (
    <Navbar
      className='navbar-vertical fixed-left navbar-light bg-white'
      expand='lg'
      id='sidenav-main'
    >
      <Container fluid>
        {/* Toggler */}
        <button
          className='navbar-toggler'
          type='button'
          onClick={toggleCollapse}
        >
          <span className='navbar-toggler-icon' />
        </button>
        {/* Brand */}
        {logo ? (
          <NavbarBrand className='pt-0' {...navbarBrandProps}>
            <img
              alt={logo.imgAlt}
              className='navbar-brand-img'
              src={logo.imgSrc}
            />
          </NavbarBrand>
        ) : null}
        {/* User */}
        <Nav className='align-items-center d-md-none'>
          {/* <UncontrolledDropdown nav>
            <DropdownToggle nav className="nav-link-icon">
              <i className="ni ni-bell-55" />
            </DropdownToggle>
            <DropdownMenu
              aria-labelledby="navbar-default_dropdown_1"
              className="dropdown-menu-arrow"
              right
            >
              <DropdownItem>Action</DropdownItem>
              <DropdownItem>Another action</DropdownItem>
              <DropdownItem divider />
              <DropdownItem>Something else here</DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown> */}
          <UncontrolledDropdown nav>
            <DropdownToggle nav>
              <Media className='align-items-center'>
                <span className='avatar avatar-sm rounded-circle'>
                  <img
                    alt='...'
                    src={require('../../assets/img/theme/user.png').default}
                  />
                </span>
              </Media>
            </DropdownToggle>
            <DropdownMenu className='dropdown-menu-arrow' right>
              <DropdownItem className='noti-title' header tag='div'>
                <h6 className='text-overflow m-0'>Bem vindo!</h6>
              </DropdownItem>
              <DropdownItem to='/admin/user-profile' tag={Link}>
                <i className='ni ni-single-02' />
                <span>Meus Dados</span>
              </DropdownItem>
              <DropdownItem to='/admin/resume-sync' tag={Link}>
                <i className='ni ni-settings-gear-65' />
                <span>{`Sincronizações: ${syncRequests()}`}</span>
              </DropdownItem>
              <DropdownItem onClick={toggle}>
                <i className='ni ni-fat-remove' />
                <span>{`Limpar Dados Offiline`}</span>
              </DropdownItem>
              <DropdownItem onClick={toggle}>
                <i className='ni ni-fat-remove' />
                <LocalForageBackup />
              </DropdownItem>
              <Modal isOpen={modal} toggle={toggle} {...props}>
                <ModalHeader toggle={toggle}>Limpar dados Offiline</ModalHeader>
                <ModalBody>
                  Esta ação deve ser feita, quando deseja-se fazer um reset dos
                  dados offiline da aplicação. Este recurso apagará, caso tiver
                  também sincronizações existentes. Então antes de executar esta
                  ação, faça a sincronização para não perder os dados
                  registrados.
                </ModalBody>
                <ModalFooter>
                  <Button
                    color='primary'
                    onClick={() => {
                      toggle();
                      localforage.clear();
                      setSyncRequests(0);
                      Notification(200, 'Dados excluídos com sucesso!');
                    }}
                  >
                    Aplicar
                  </Button>{' '}
                  <Button color='secondary' onClick={toggle}>
                    Cancelar
                  </Button>
                </ModalFooter>
              </Modal>
              <DropdownItem divider />
              <DropdownItem href='#pablo' onClick={logout}>
                <i className='ni ni-user-run' />
                <span>Sair</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
        {/* Collapse */}
        <Collapse navbar isOpen={collapseOpen}>
          {/* Collapse header */}
          <div className='navbar-collapse-header d-md-none'>
            <Row>
              {logo ? (
                <Col className='collapse-brand' xs='6'>
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} style={{ width: '80px', height: 'auto', objectFit: 'contain' }} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} style={{ width: '80px', height: 'auto', objectFit: 'contain' }} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className='collapse-close' xs='6'>
                <button
                  className='navbar-toggler'
                  type='button'
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          {/* Form */}
          {/* <Form className='mt-4 mb-3 d-md-none'>
            <InputGroup className='input-group-rounded input-group-merge'>
              <Input
                aria-label='Search'
                className='form-control-rounded form-control-prepended'
                placeholder='Search'
                type='search'
              />
              <InputGroupAddon addonType='prepend'>
                <InputGroupText>
                  <span className='fa fa-search' />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </Form> */}
          {/* Navigation */}
          <Nav navbar>{createLinks(routes)}</Nav>
          {/* Divider */}
          <hr className='my-3' />
          {/* Heading */}
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
